import React from 'react'
import { TawreedDropdownProps, TawreedMenuDropdown } from '../../../../../common/components/form'

export const CategoriesDropdown: React.FC<TawreedDropdownProps> = (props) => {

    return (<TawreedMenuDropdown {...props} menu="productCategories" />)
}
